/* eslint-disable import/no-default-export, no-restricted-exports, import/no-useless-path-segments */
// This file is auto-generated
export { default, getFullLocale } from './jelmolich';
export type { Config, Locale, Language, GeoCountryCode } from './default/types';
